module.exports = __webpack_public_path__ + "img/ic_seafood.6253842b.png";